module.exports = __webpack_public_path__ + "static/img/Symphony-Selected.0d64bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Symphony-Selected.png
// module id = 610
// module chunks = 0